import { useEffect, useMemo, useState } from 'react'
import { Menu } from 'react-pro-sidebar'
import { Link, useLocation } from 'react-router-dom'

import Bridge from '@/assets/Bridge.png'
import BridgeAside from '@/assets/BridgeAside.png'
import CMC from '@/assets/CMC.png'
import Docs from '@/assets/Docs.png'
import Ecosystem from '@/assets/Ecosystem.png'
import Explorer from '@/assets/Explorer.png'
import Github from '@/assets/Github.png'
import Home from '@/assets/Home.png'
import LOGO from '@/assets/logo.png'
import LOGO_LIGHT from '@/assets/logo_light.png'
import Medium from '@/assets/Medium.png'
import PosAside from '@/assets/posAside.png'
import StakexWAN from '@/assets/Stake.png'
import Support from '@/assets/Support.png'
import Telegram from '@/assets/Telegram.png'
import Twitter from '@/assets/Twitter.png'
import ValidatorIcon from '@/assets/validatorIcon.png'
import Website from '@/assets/Website.png'
import GetxWAN from '@/assets/Wrap.png'
import XFlows from '@/assets/XFlows.png'
import ThemeSwitch from '@/components/ThemeSwitch/ThemeSwitch'
import { useLocalStorage } from '@/context/localstorage-context'
import { resetRoute } from '@/utils'

import {
  ButtonNoPadding,
  Div1,
  Img,
  Img2,
  LineStyle,
  MenuItemCus,
  ProSidebarCus,
  SidebarBtn,
  SidebarFooterCus,
  SubMenuCus,
  SubMenuItemCus1,
  ThirdPartyCon,
} from './Aside.module'

const SIDEBAR_ITEM = {
  '/': '1',
  '/pos': '2',
  '/bridge': '3',
  '/validator/pos': '4',
  '/validator/bridge': '5',
  '/setup/pos': '6',
  '/setup/bridge': '7',
  '/stake2earn': '8',
  '/getxwan': '9',
}

const Aside = ({
  toggled,
  handleToggleSidebar,
}: {
  toggled: boolean
  handleToggleSidebar: any
}) => {
  const [item, setItem] = useState(SIDEBAR_ITEM['/'])
  const selectItem = (key: string) => setItem(key)
  const { pathname } = useLocation()
  const { theme } = useLocalStorage()

  useEffect(() => {
    let item
    // @ts-ignore
    if (SIDEBAR_ITEM[pathname]) {
      // @ts-ignore
      item = SIDEBAR_ITEM[pathname]
    } else {
      if (pathname.startsWith('/posdetail/')) {
        item = '2'
      } else if (pathname.startsWith('/storemandetail/')) {
        item = '3'
      }
    }
    selectItem(item)
  }, [pathname])

  const isdark = useMemo(() => theme === 'dark', [theme])

  return (
    <ProSidebarCus
      toggled={toggled}
      breakPoint="md"
      isdark={isdark.toString()}
      onToggle={handleToggleSidebar}
      onBackdropClick={handleToggleSidebar}
      className="bg-common-0 dark:bg-common-1 dark:border-common-1 border-common-0"
    >
      <div
        style={{
          flex: 1,
          overflow: 'auto',
        }}
      >
        <div>
          <div
            style={{
              padding: '24px',
              textTransform: 'uppercase',
              fontWeight: 'bold',
              fontSize: 14,
              letterSpacing: '1px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <ButtonNoPadding type={'link'} onClick={resetRoute}>
              <img src={isdark ? LOGO : LOGO_LIGHT} alt="logo" width="170px" />
            </ButtonNoPadding>
          </div>
        </div>

        <div>
          <Menu>
            <MenuItemCus
              icon={<Img src={Home} alt="Home" />}
              onClick={() => selectItem(SIDEBAR_ITEM['/'])}
              active={item === '1'}
              isdark={isdark.toString()}
              component={<Link to="/" />}
            >
              Home
            </MenuItemCus>
            <MenuItemCus
              icon={<Img src={PosAside} alt="PosAside" />}
              onClick={() => selectItem(SIDEBAR_ITEM['/pos'])}
              active={item === '2'}
              isdark={isdark.toString()}
              component={<Link to="/pos" />}
            >
              Delegate to PoS
            </MenuItemCus>
            <MenuItemCus
              icon={<Img src={Bridge} alt="Bridge" />}
              onClick={() => selectItem(SIDEBAR_ITEM['/bridge'])}
              active={item === '3'}
              isdark={isdark.toString()}
              component={<Link to="/bridge" />}
            >
              Delegate to Bridge
            </MenuItemCus>
            <MenuItemCus
              icon={<Img src={StakexWAN} alt="Stake to Earn" />}
              onClick={() => selectItem(SIDEBAR_ITEM['/stake2earn'])}
              active={item === '8'}
              isdark={isdark.toString()}
              component={<Link to="/stake2earn" />}
            >
              Stake to Earn
            </MenuItemCus>
            <MenuItemCus
              icon={<Img src={GetxWAN} alt="Get xWAN" />}
              onClick={() => selectItem(SIDEBAR_ITEM['/getxwan'])}
              active={item === '9'}
              isdark={isdark.toString()}
              component={<Link to="/getxwan" />}
            >
              Get xWAN
            </MenuItemCus>
            <SubMenuCus
              isdark={isdark.toString()}
              label="Validator Node"
              icon={<Img src={ValidatorIcon} alt="Validator" />}
              rootStyles={{
                paddingLeft: '4px',
                color: `${isdark ? '#fff' : '#333'}`,
              }}
            >
              <div className="border-l-2 ml-14 border-l-light-106 pl-4 mb-4 dark:border-l-dark-1666">
                <div className="flex flex-col">
                  <div className="flex flex-col">
                    <div className="flex gap-2">
                      <span className="text-[12px]">PoS</span>
                      <div className="w-[70%] border-t-2 border-dashed border-light-106 px-4 mt-4 dark:border-dark-1666"></div>
                    </div>
                    <div>
                      <SubMenuItemCus1
                        isactive={(item === '6').toString()}
                        isdark={isdark.toString()}
                        onClick={() => selectItem(SIDEBAR_ITEM['/setup/pos'])}
                        component={<Link to="/setup/pos" />}
                      >
                        Setup PoS Node
                      </SubMenuItemCus1>
                      <SubMenuItemCus1
                        isactive={(item === '4').toString()}
                        isdark={isdark.toString()}
                        onClick={() =>
                          selectItem(SIDEBAR_ITEM['/validator/pos'])
                        }
                        component={<Link to="/validator/pos" />}
                      >
                        My PoS Staking
                      </SubMenuItemCus1>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="flex gap-2">
                      <span className="text-[12px]">Bridge</span>
                      <div className="w-[70%] border-t-2 border-dashed border-light-106 px-4 mt-4 dark:border-dark-1666"></div>
                    </div>
                    <div>
                      <SubMenuItemCus1
                        isdark={isdark.toString()}
                        isactive={(item === '7').toString()}
                        component={<Link to="/setup/bridge" />}
                        onClick={() =>
                          selectItem(SIDEBAR_ITEM['/setup/bridge'])
                        }
                      >
                        Setup Bridge Node
                      </SubMenuItemCus1>
                      <SubMenuItemCus1
                        isdark={isdark.toString()}
                        isactive={(item === '5').toString()}
                        onClick={() =>
                          selectItem(SIDEBAR_ITEM['/validator/bridge'])
                        }
                        component={<Link to="/validator/bridge" />}
                      >
                        My Bridge Staking
                      </SubMenuItemCus1>
                    </div>
                  </div>
                </div>
              </div>
            </SubMenuCus>
          </Menu>

          <LineStyle isdark={isdark} />

          <Menu>
            <MenuItemCus
              icon={<Img src={Support} alt="Support" />}
              active={false}
              isdark={isdark.toString()}
              onClick={() =>
                window.open('mailto:techsupport@wanchain.org', '_blank')
              }
            >
              Support
            </MenuItemCus>
            <MenuItemCus
              className="text-black dark:text-white"
              icon={<Img src={Docs} alt="docs" />}
              active={false}
              isdark={isdark.toString()}
              onClick={() =>
                window.open('https://docs.wanchain.org/', '_blank')
              }
            >
              Documents
            </MenuItemCus>
          </Menu>

          <LineStyle isdark={isdark} />

          <Menu>
            <MenuItemCus
              className="text-black dark:text-white"
              icon={<Img src={Explorer} alt="Explorer" />}
              active={false}
              isdark={isdark.toString()}
              onClick={() => window.open('https://www.wanscan.org/', '_blank')}
            >
              Explorer
            </MenuItemCus>
            <MenuItemCus
              icon={<Img src={Website} alt="Website" />}
              active={false}
              isdark={isdark.toString()}
              onClick={() => window.open('https://www.wanchain.org/', '_blank')}
            >
              Website
            </MenuItemCus>
            <MenuItemCus
              icon={<Img src={BridgeAside} alt="BridgeAside" />}
              onClick={() =>
                window.open('https://bridge.wanchain.org/', '_blank')
              }
              active={false}
              isdark={isdark.toString()}
            >
              Bridge
            </MenuItemCus>
            <MenuItemCus
              className="text-black dark:text-white"
              icon={<Img src={XFlows} alt="XFlows" />}
              active={false}
              isdark={isdark.toString()}
              onClick={() =>
                window.open('https://xflows.wanchain.org/', '_blank')
              }
            >
              XFlows
            </MenuItemCus>
            <MenuItemCus
              icon={<Img src={Ecosystem} alt="Ecosystem" />}
              active={false}
              isdark={isdark.toString()}
              onClick={() =>
                window.open('https://www.wanchain.org/dapps', '_blank')
              }
            >
              Ecosystem
            </MenuItemCus>
          </Menu>
        </div>
      </div>

      <SidebarFooterCus style={{ textAlign: 'center' }}>
        <Div1>
          <ThemeSwitch inSiderbar={true} />
        </Div1>
        <ThirdPartyCon>
          <SidebarBtn
            href="https://twitter.com/wanchain_org"
            target="_blank"
            rel="noopener noreferrer"
            isdark={isdark}
          >
            <Img2 src={Twitter} alt="Twitter" />
          </SidebarBtn>
          <SidebarBtn
            href="https://t.me/WanchainCHAT"
            target="_blank"
            rel="noopener noreferrer"
            isdark={isdark}
          >
            <Img2 src={Telegram} alt="Telegram" />
          </SidebarBtn>
          <SidebarBtn
            href="https://medium.com/wanchain-foundation"
            target="_blank"
            rel="noopener noreferrer"
            isdark={isdark}
          >
            <Img2 src={Medium} alt="Medium" />
          </SidebarBtn>
          <SidebarBtn
            href="https://github.com/wanchain"
            target="_blank"
            rel="noopener noreferrer"
            isdark={isdark}
          >
            <Img2 src={Github} alt="Github" />
          </SidebarBtn>
          <SidebarBtn
            href="https://coinmarketcap.com/currencies/wanchain/"
            target="_blank"
            rel="noopener noreferrer"
            isdark={isdark}
          >
            <Img2 src={CMC} alt="CMC" />
          </SidebarBtn>
        </ThirdPartyCon>
      </SidebarFooterCus>
    </ProSidebarCus>
  )
}

export default Aside
